<div class="modal-header cp-modal-header">
	<div>
		<h4 class="modal-title mb-0" id="cp-payment-title">Take payment</h4>
		<div class="text-muted small" *ngIf="customerTitle">{{ customerTitle }}</div>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('close')">
		<span aria-hidden="true" class="fa fa-close"></span>
	</button>
</div>

<div class="modal-body cp-modal-body p-0">
	<div *ngIf="!customerForPayment" class="alert alert-warning m-3 mb-0" role="alert">
		Missing customer or branch.
	</div>
	<div class="cp-payment-embed" *ngIf="customerForPayment">
		<app-payment [customer]="customerForPayment"></app-payment>
	</div>
</div>
